import React, { useCallback, useEffect, useRef, memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Layer, Box, Button } from 'grommet';
import { Close } from 'grommet-icons';

import Calculator from './Calculator';
import { setProductId } from '../../state/calculator/calculatorSlice';

const ModalPaintCalculator = ({ product, productGroup }) => {
  const scrollRef = useRef(null);
  const dispatch = useDispatch();
  const calculatorProductId = useSelector(
    (state) => state.calculator.activeProductId
  );
  const handleClose = useCallback(() => {
    dispatch(setProductId(null));
  }, [dispatch]);

  const step = useSelector((state) => state.calculator.step);
  const activeProductId = useSelector(
    (state) => state.calculator.activeProductId
  );

  useEffect(() => {
    if (activeProductId) {
      scrollRef.current && scrollRef.current.scrollTo(0, 0);
    }
  }, [step, activeProductId]);

  const paintCollections = [productGroup];

  return (
    <>
      {calculatorProductId ? (
        <Layer
          animation="fadeIn"
          modal={true}
          full
          onEsc={handleClose}
          onClickOutside={handleClose}
        >
          <Button
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              padding: '8px',
              borderRadius: '0 0 0 8px',
            }}
            icon={<Close color="black" />}
            onClick={handleClose}
          />
          <Box
            overflow="auto"
            ref={scrollRef}
            fill
            className="modal-calc-container"
          >
            <Box flex={false}>
              <Calculator
                paintCollections={paintCollections}
                disableChoose={true}
              />
            </Box>
          </Box>
        </Layer>
      ) : null}
    </>
  );
};

ModalPaintCalculator.propTypes = {
  productGroup: PropTypes.object,
  product: PropTypes.object,
};

export default memo(ModalPaintCalculator);
